// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1z8nT","buttons":"Footer_buttons__2ehvv"};